import cachedWeb3Utils from './cachedWeb3Utils.js';

/**
 * Fetches an address's balance and returns it in ether units
 * @param {Web3} web3 - Web3 instance
 * @param {string} address - The address to check balance for
 * @param {number} decimals - Number of decimal places (default 6)
 * @returns {string} - Balance in ether units with specified decimal places
 */
export const getAddressBalanceInEther = async (web3, address, decimals = 6) => {
    try {
      const balanceWei = await cachedWeb3Utils.getGasTokenBalance(address);
      // Convert from wei to ether using web3's utils
      const balanceEther = web3.utils.fromWei(balanceWei.toString(), 'ether');
      // Format to specified decimal places
      return Number(balanceEther).toFixed(decimals);
    } catch (error) {
      console.error('Error fetching balance:', error);
      return '';
    }
  }; 